var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#393E46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.54 18.42C34.4212 17.9454 34.1792 17.5106 33.8386 17.1594C33.498 16.8082 33.0707 16.5532 32.6 16.42C30.88 16 24 16 24 16C24 16 17.12 16 15.4 16.46C14.9292 16.5932 14.5019 16.8482 14.1613 17.1994C13.8207 17.5506 13.5787 17.9854 13.46 18.46C13.1452 20.2056 12.9912 21.9763 13 23.75C12.9887 25.537 13.1427 27.3213 13.46 29.08C13.5909 29.5398 13.8383 29.9581 14.1781 30.2945C14.5179 30.6308 14.9388 30.8738 15.4 31C17.12 31.46 24 31.46 24 31.46C24 31.46 30.88 31.46 32.6 31C33.0707 30.8668 33.498 30.6118 33.8386 30.2606C34.1792 29.9094 34.4212 29.4746 34.54 29C34.8523 27.2676 35.0063 25.5103 35 23.75C35.0112 21.963 34.8572 20.1787 34.54 18.42V18.42Z",
    stroke: "#EEEEEE",
    strokeOpacity: 0.75,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 27.02L27.5 23.75L21.75 20.48V27.02Z",
    stroke: "#EEEEEE",
    strokeOpacity: 0.75,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube_logo.9b4c97c589b555c6bee6f53fde8f0304.svg";
export { ForwardRef as ReactComponent };